// Batch Message Interface (BMI) — type contract.
//
// This file is a BINDING of SPEC.md. SPEC.md is normative; where the two
// disagree, SPEC.md wins.
//
// Section references in comments point at SPEC.md.

// @generated by protoc-gen-es v2.14.0 with parameter "target=ts"
// @generated from file bmi/v1/batch_message.proto (package bmi.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file bmi/v1/batch_message.proto.
 */
export const file_bmi_v1_batch_message: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * One accepted form of destination identifier. See SPEC.md §11 for the
 * normative id_kind tokens and patterns per TARGET kind.
 *
 * @generated from message bmi.v1.DestinationKindSpec
 */
export type DestinationKindSpec = Message$1<"bmi.v1.DestinationKindSpec"> & {
  /**
   * Token used in Destination.id_kind, e.g. "e164", "aci", "chat_id".
   *
   * @generated from field: string id_kind = 1;
   */
  idKind: string;

  /**
   * Anchored RE2 regex the canonical identifier form must match.
   *
   * @generated from field: string pattern = 2;
   */
  pattern: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * Exactly one DestinationKindSpec in a Target has is_default = true.
   *
   * @generated from field: bool is_default = 4;
   */
  isDefault: boolean;
};

/**
 * Describes the message bmi.v1.DestinationKindSpec.
 * Use `create(DestinationKindSpecSchema)` to create a new message.
 */
export const DestinationKindSpecSchema: GenMessage<DestinationKindSpec> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 0);

/**
 * @generated from message bmi.v1.Target
 */
export type Target = Message$1<"bmi.v1.Target"> & {
  /**
   * @generated from field: bmi.v1.TargetKind kind = 1;
   */
  kind: TargetKind;

  /**
   * Required if and only if kind == TARGET_KIND_OTHER.
   *
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * At least one entry.
   *
   * @generated from field: repeated bmi.v1.DestinationKindSpec destination_kinds = 3;
   */
  destinationKinds: DestinationKindSpec[];

  /**
   * ISO 3166-1 alpha-2, used to normalise national-format phone numbers.
   *
   * @generated from field: optional string default_region = 4;
   */
  defaultRegion?: string | undefined;
};

/**
 * Describes the message bmi.v1.Target.
 * Use `create(TargetSchema)` to create a new message.
 */
export const TargetSchema: GenMessage<Target> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 1);

/**
 * @generated from message bmi.v1.RateLimit
 */
export type RateLimit = Message$1<"bmi.v1.RateLimit"> & {
  /**
   * @generated from field: int32 requests = 1;
   */
  requests: number;

  /**
   * @generated from field: google.protobuf.Duration per = 2;
   */
  per?: Duration | undefined;
};

/**
 * Describes the message bmi.v1.RateLimit.
 * Use `create(RateLimitSchema)` to create a new message.
 */
export const RateLimitSchema: GenMessage<RateLimit> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 2);

/**
 * Every limit a CLIENT needs in order to build a valid batch. CLIENTs must
 * read these rather than hardcoding values (SPEC.md §10.1).
 *
 * @generated from message bmi.v1.Limits
 */
export type Limits = Message$1<"bmi.v1.Limits"> & {
  /**
   * @generated from field: int32 max_batch_size = 1;
   */
  maxBatchSize: number;

  /**
   * @generated from field: int32 max_text_bytes = 2;
   */
  maxTextBytes: number;

  /**
   * @generated from field: optional int32 max_subject_bytes = 3;
   */
  maxSubjectBytes?: number | undefined;

  /**
   * @generated from field: optional int32 max_attachments = 4;
   */
  maxAttachments?: number | undefined;

  /**
   * @generated from field: optional int64 max_attachment_bytes = 5;
   */
  maxAttachmentBytes?: bigint | undefined;

  /**
   * @generated from field: int32 max_metadata_entries = 6;
   */
  maxMetadataEntries: number;

  /**
   * @generated from field: int32 max_page_size = 7;
   */
  maxPageSize: number;

  /**
   * @generated from field: optional int32 max_batch_get_ids = 8;
   */
  maxBatchGetIds?: number | undefined;

  /**
   * @generated from field: google.protobuf.Duration status_retention = 9;
   */
  statusRetention?: Duration | undefined;

  /**
   * @generated from field: google.protobuf.Duration idempotency_retention = 10;
   */
  idempotencyRetention?: Duration | undefined;

  /**
   * @generated from field: optional bmi.v1.RateLimit submit_rate_limit = 11;
   */
  submitRateLimit?: RateLimit | undefined;
};

/**
 * Describes the message bmi.v1.Limits.
 * Use `create(LimitsSchema)` to create a new message.
 */
export const LimitsSchema: GenMessage<Limits> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 3);

/**
 * One flag per optional feature. A SERVICE must reject requests using a
 * feature whose flag is false, never ignore them silently (SPEC.md §3.1).
 *
 * @generated from message bmi.v1.Features
 */
export type Features = Message$1<"bmi.v1.Features"> & {
  /**
   * @generated from field: bool webhooks = 1;
   */
  webhooks: boolean;

  /**
   * @generated from field: bool cancel = 2;
   */
  cancel: boolean;

  /**
   * @generated from field: bool scheduled_send = 3;
   */
  scheduledSend: boolean;

  /**
   * @generated from field: bool validity_period = 4;
   */
  validityPeriod: boolean;

  /**
   * @generated from field: bool read_receipts = 5;
   */
  readReceipts: boolean;

  /**
   * @generated from field: bool templates = 6;
   */
  templates: boolean;

  /**
   * @generated from field: bool attachments = 7;
   */
  attachments: boolean;

  /**
   * @generated from field: bool subject = 8;
   */
  subject: boolean;

  /**
   * @generated from field: bool list_batches = 9;
   */
  listBatches: boolean;

  /**
   * @generated from field: bool batch_get_messages = 10;
   */
  batchGetMessages: boolean;
};

/**
 * Describes the message bmi.v1.Features.
 * Use `create(FeaturesSchema)` to create a new message.
 */
export const FeaturesSchema: GenMessage<Features> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 4);

/**
 * @generated from message bmi.v1.ServiceInfo
 */
export type ServiceInfo = Message$1<"bmi.v1.ServiceInfo"> & {
  /**
   * BMI specification version implemented, semver.
   *
   * @generated from field: string spec_version = 1;
   */
  specVersion: string;

  /**
   * @generated from field: string service_name = 2;
   */
  serviceName: string;

  /**
   * @generated from field: optional string service_version = 3;
   */
  serviceVersion?: string | undefined;

  /**
   * @generated from field: bmi.v1.Target target = 4;
   */
  target?: Target | undefined;

  /**
   * @generated from field: bmi.v1.Limits limits = 5;
   */
  limits?: Limits | undefined;

  /**
   * @generated from field: bmi.v1.Features features = 6;
   */
  features?: Features | undefined;
};

/**
 * Describes the message bmi.v1.ServiceInfo.
 * Use `create(ServiceInfoSchema)` to create a new message.
 */
export const ServiceInfoSchema: GenMessage<ServiceInfo> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 5);

/**
 * @generated from message bmi.v1.Destination
 */
export type Destination = Message$1<"bmi.v1.Destination"> & {
  /**
   * Canonical identifier for the TARGET (SPEC.md §11).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * One of Target.destination_kinds[].id_kind. Absent means the default kind.
   *
   * @generated from field: optional string id_kind = 2;
   */
  idKind?: string | undefined;
};

/**
 * Describes the message bmi.v1.Destination.
 * Use `create(DestinationSchema)` to create a new message.
 */
export const DestinationSchema: GenMessage<Destination> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 6);

/**
 * @generated from message bmi.v1.Template
 */
export type Template = Message$1<"bmi.v1.Template"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * BCP 47 tag, or the TARGET's own convention, e.g. "sr", "en_US".
   *
   * @generated from field: optional string language = 2;
   */
  language?: string | undefined;

  /**
   * @generated from field: repeated string parameters = 3;
   */
  parameters: string[];
};

/**
 * Describes the message bmi.v1.Template.
 * Use `create(TemplateSchema)` to create a new message.
 */
export const TemplateSchema: GenMessage<Template> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 7);

/**
 * @generated from message bmi.v1.Attachment
 */
export type Attachment = Message$1<"bmi.v1.Attachment"> & {
  /**
   * @generated from field: string media_type = 1;
   */
  mediaType: string;

  /**
   * Exactly one source must be set.
   *
   * @generated from oneof bmi.v1.Attachment.source
   */
  source: {
    /**
     * https URI the SERVICE fetches.
     *
     * @generated from field: string uri = 2;
     */
    value: string;
    case: "uri";
  } | {
    /**
     * Inline content.
     *
     * @generated from field: bytes data = 3;
     */
    value: Uint8Array;
    case: "data";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string filename = 4;
   */
  filename?: string | undefined;
};

/**
 * Describes the message bmi.v1.Attachment.
 * Use `create(AttachmentSchema)` to create a new message.
 */
export const AttachmentSchema: GenMessage<Attachment> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 8);

/**
 * @generated from message bmi.v1.Content
 */
export type Content = Message$1<"bmi.v1.Content"> & {
  /**
   * Always required, even when template is set: the CLIENT's rendered text,
   * used for logging, previews, and plain-text fallback.
   *
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: optional string subject = 2;
   */
  subject?: string | undefined;

  /**
   * @generated from field: optional bmi.v1.Template template = 3;
   */
  template?: Template | undefined;

  /**
   * @generated from field: repeated bmi.v1.Attachment attachments = 4;
   */
  attachments: Attachment[];
};

/**
 * Describes the message bmi.v1.Content.
 * Use `create(ContentSchema)` to create a new message.
 */
export const ContentSchema: GenMessage<Content> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 9);

/**
 * @generated from message bmi.v1.MessageInput
 */
export type MessageInput = Message$1<"bmi.v1.MessageInput"> & {
  /**
   * Unique within the batch. Opaque to the SERVICE; the CLIENT's correlation
   * handle before message_id exists.
   *
   * @generated from field: string client_message_id = 1;
   */
  clientMessageId: string;

  /**
   * @generated from field: bmi.v1.Destination destination = 2;
   */
  destination?: Destination | undefined;

  /**
   * @generated from field: bmi.v1.Content content = 3;
   */
  content?: Content | undefined;

  /**
   * Opaque, stored verbatim, returned on every Message and webhook event.
   *
   * @generated from field: map<string, string> metadata = 4;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message bmi.v1.MessageInput.
 * Use `create(MessageInputSchema)` to create a new message.
 */
export const MessageInputSchema: GenMessage<MessageInput> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 10);

/**
 * @generated from message bmi.v1.MessageError
 */
export type MessageError = Message$1<"bmi.v1.MessageError"> & {
  /**
   * @generated from field: bmi.v1.FailureReason reason = 1;
   */
  reason: FailureReason;

  /**
   * Human-readable. Not machine-parsed.
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * True if resubmitting the same destination may succeed.
   *
   * @generated from field: bool retryable = 3;
   */
  retryable: boolean;

  /**
   * Raw TARGET code or message, verbatim, e.g. "131047" or "550 5.1.1".
   *
   * @generated from field: optional string target_code = 4;
   */
  targetCode?: string | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 5;
   */
  occurredAt?: Timestamp | undefined;
};

/**
 * Describes the message bmi.v1.MessageError.
 * Use `create(MessageErrorSchema)` to create a new message.
 */
export const MessageErrorSchema: GenMessage<MessageError> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 11);

/**
 * The tracked unit. message_id is the primary tracking handle.
 *
 * @generated from message bmi.v1.Message
 */
export type Message = Message$1<"bmi.v1.Message"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: string batch_id = 2;
   */
  batchId: string;

  /**
   * @generated from field: string client_message_id = 3;
   */
  clientMessageId: string;

  /**
   * Normalised by the SERVICE; not necessarily byte-identical to the input.
   *
   * @generated from field: bmi.v1.Destination destination = 4;
   */
  destination?: Destination | undefined;

  /**
   * @generated from field: bmi.v1.MessageState state = 5;
   */
  state: MessageState;

  /**
   * Strictly increasing per message, starting at 1. The only correct ordering
   * key for status updates; timestamps must not be used (SPEC.md §3.5).
   *
   * @generated from field: int64 state_sequence = 6;
   */
  stateSequence: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp state_changed_at = 8;
   */
  stateChangedAt?: Timestamp | undefined;

  /**
   * @generated from field: int32 attempt_count = 9;
   */
  attemptCount: number;

  /**
   * TARGET-native identifier, when the TARGET returns one.
   *
   * @generated from field: optional string target_message_id = 10;
   */
  targetMessageId?: string | undefined;

  /**
   * Set if and only if state is REJECTED, FAILED, UNDELIVERED, EXPIRED, or
   * CANCELED.
   *
   * @generated from field: optional bmi.v1.MessageError error = 11;
   */
  error?: MessageError | undefined;

  /**
   * @generated from field: map<string, string> metadata = 12;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message bmi.v1.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 12);

/**
 * @generated from message bmi.v1.Batch
 */
export type Batch = Message$1<"bmi.v1.Batch"> & {
  /**
   * @generated from field: string batch_id = 1;
   */
  batchId: string;

  /**
   * @generated from field: optional string reference = 2;
   */
  reference?: string | undefined;

  /**
   * @generated from field: bmi.v1.BatchStatus status = 3;
   */
  status: BatchStatus;

  /**
   * @generated from field: int32 message_count = 4;
   */
  messageCount: number;

  /**
   * MessageState value name -> count, e.g. {"MESSAGE_STATE_DELIVERED": 940}.
   * Sums to message_count. Zero counts should be omitted.
   *
   * @generated from field: map<string, int32> state_counts = 5;
   */
  stateCounts: { [key: string]: number };

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Set if and only if status == BATCH_STATUS_COMPLETED.
   *
   * @generated from field: optional google.protobuf.Timestamp completed_at = 7;
   */
  completedAt?: Timestamp | undefined;
};

/**
 * Describes the message bmi.v1.Batch.
 * Use `create(BatchSchema)` to create a new message.
 */
export const BatchSchema: GenMessage<Batch> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 13);

/**
 * @generated from message bmi.v1.FieldViolation
 */
export type FieldViolation = Message$1<"bmi.v1.FieldViolation"> & {
  /**
   * Dotted path with bracketed indices, rooted at the request message,
   * e.g. "messages[3].destination.id".
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message bmi.v1.FieldViolation.
 * Use `create(FieldViolationSchema)` to create a new message.
 */
export const FieldViolationSchema: GenMessage<FieldViolation> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 14);

/**
 * Attached as a Connect error detail. The REST binding carries the same
 * information as RFC 9457 problem+json extension members.
 *
 * @generated from message bmi.v1.ErrorDetail
 */
export type ErrorDetail = Message$1<"bmi.v1.ErrorDetail"> & {
  /**
   * @generated from field: bmi.v1.ErrorCode code = 1;
   */
  code: ErrorCode;

  /**
   * @generated from field: repeated bmi.v1.FieldViolation field_violations = 2;
   */
  fieldViolations: FieldViolation[];
};

/**
 * Describes the message bmi.v1.ErrorDetail.
 * Use `create(ErrorDetailSchema)` to create a new message.
 */
export const ErrorDetailSchema: GenMessage<ErrorDetail> = /*@__PURE__*/
  messageDesc(file_bmi_v1_batch_message, 15);

/**
 * The messaging platform a SERVICE delivers onto. One SERVICE serves exactly
 * one TARGET.
 *
 * @generated from enum bmi.v1.TargetKind
 */
export enum TargetKind {
  /**
   * @generated from enum value: TARGET_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TARGET_KIND_SMS = 1;
   */
  SMS = 1,

  /**
   * @generated from enum value: TARGET_KIND_RCS = 2;
   */
  RCS = 2,

  /**
   * @generated from enum value: TARGET_KIND_EMAIL = 3;
   */
  EMAIL = 3,

  /**
   * @generated from enum value: TARGET_KIND_TELEGRAM = 4;
   */
  TELEGRAM = 4,

  /**
   * @generated from enum value: TARGET_KIND_WHATSAPP = 5;
   */
  WHATSAPP = 5,

  /**
   * @generated from enum value: TARGET_KIND_SIGNAL = 6;
   */
  SIGNAL = 6,

  /**
   * @generated from enum value: TARGET_KIND_VIBER = 7;
   */
  VIBER = 7,

  /**
   * @generated from enum value: TARGET_KIND_OTHER = 8;
   */
  OTHER = 8,
}

/**
 * Describes the enum bmi.v1.TargetKind.
 */
export const TargetKindSchema: GenEnum<TargetKind> = /*@__PURE__*/
  enumDesc(file_bmi_v1_batch_message, 0);

/**
 * Ranks (SPEC.md §4.1) increase strictly along every allowed transition:
 * REJECTED 0 | ACCEPTED 1 | SCHEDULED 2 | QUEUED 3 | SENDING 4 | SENT 5 |
 * DELIVERED, UNDELIVERED, FAILED, EXPIRED, CANCELED 6 | READ 7.
 *
 * CLIENTs must treat unrecognised values as non-terminal.
 *
 * @generated from enum bmi.v1.MessageState
 */
export enum MessageState {
  /**
   * @generated from enum value: MESSAGE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Refused at submit time. Terminal.
   *
   * @generated from enum value: MESSAGE_STATE_REJECTED = 1;
   */
  REJECTED = 1,

  /**
   * @generated from enum value: MESSAGE_STATE_ACCEPTED = 2;
   */
  ACCEPTED = 2,

  /**
   * @generated from enum value: MESSAGE_STATE_SCHEDULED = 3;
   */
  SCHEDULED = 3,

  /**
   * @generated from enum value: MESSAGE_STATE_QUEUED = 4;
   */
  QUEUED = 4,

  /**
   * @generated from enum value: MESSAGE_STATE_SENDING = 5;
   */
  SENDING = 5,

  /**
   * TARGET accepted the message. Not proof of delivery.
   *
   * @generated from enum value: MESSAGE_STATE_SENT = 6;
   */
  SENT = 6,

  /**
   * @generated from enum value: MESSAGE_STATE_DELIVERED = 7;
   */
  DELIVERED = 7,

  /**
   * @generated from enum value: MESSAGE_STATE_READ = 8;
   */
  READ = 8,

  /**
   * TARGET accepted, then reported a delivery failure.
   *
   * @generated from enum value: MESSAGE_STATE_UNDELIVERED = 9;
   */
  UNDELIVERED = 9,

  /**
   * Never reached the TARGET; retries exhausted.
   *
   * @generated from enum value: MESSAGE_STATE_FAILED = 10;
   */
  FAILED = 10,

  /**
   * @generated from enum value: MESSAGE_STATE_EXPIRED = 11;
   */
  EXPIRED = 11,

  /**
   * @generated from enum value: MESSAGE_STATE_CANCELED = 12;
   */
  CANCELED = 12,
}

/**
 * Describes the enum bmi.v1.MessageState.
 */
export const MessageStateSchema: GenEnum<MessageState> = /*@__PURE__*/
  enumDesc(file_bmi_v1_batch_message, 1);

/**
 * Why a single message failed (SPEC.md §8.5).
 *
 * @generated from enum bmi.v1.FailureReason
 */
export enum FailureReason {
  /**
   * @generated from enum value: FAILURE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Identifier failed format or id_kind validation.
   *
   * @generated from enum value: FAILURE_REASON_INVALID_DESTINATION = 1;
   */
  INVALID_DESTINATION = 1,

  /**
   * Well formed, but no such recipient, or the TARGET-required relationship
   * does not exist (Telegram user never started the bot, Viber user not
   * subscribed, number has no WhatsApp account).
   *
   * @generated from enum value: FAILURE_REASON_UNKNOWN_DESTINATION = 2;
   */
  UNKNOWN_DESTINATION = 2,

  /**
   * @generated from enum value: FAILURE_REASON_BLOCKED_BY_RECIPIENT = 3;
   */
  BLOCKED_BY_RECIPIENT = 3,

  /**
   * TARGET messaging-window rule violated, e.g. WhatsApp 24-hour window.
   *
   * @generated from enum value: FAILURE_REASON_WINDOW_EXPIRED = 4;
   */
  WINDOW_EXPIRED = 4,

  /**
   * @generated from enum value: FAILURE_REASON_CONTENT_REJECTED = 5;
   */
  CONTENT_REJECTED = 5,

  /**
   * @generated from enum value: FAILURE_REASON_RATE_LIMITED = 6;
   */
  RATE_LIMITED = 6,

  /**
   * @generated from enum value: FAILURE_REASON_TARGET_UNAVAILABLE = 7;
   */
  TARGET_UNAVAILABLE = 7,

  /**
   * The SERVICE's own credentials to the TARGET are invalid. Operator fault.
   *
   * @generated from enum value: FAILURE_REASON_TARGET_AUTH_FAILED = 8;
   */
  TARGET_AUTH_FAILED = 8,

  /**
   * @generated from enum value: FAILURE_REASON_EXPIRED = 9;
   */
  EXPIRED = 9,

  /**
   * @generated from enum value: FAILURE_REASON_CANCELED = 10;
   */
  CANCELED = 10,

  /**
   * @generated from enum value: FAILURE_REASON_INTERNAL = 11;
   */
  INTERNAL = 11,
}

/**
 * Describes the enum bmi.v1.FailureReason.
 */
export const FailureReasonSchema: GenEnum<FailureReason> = /*@__PURE__*/
  enumDesc(file_bmi_v1_batch_message, 2);

/**
 * @generated from enum bmi.v1.BatchStatus
 */
export enum BatchStatus {
  /**
   * @generated from enum value: BATCH_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * At least one message is in a non-terminal state.
   *
   * @generated from enum value: BATCH_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * Every message is in a terminal state.
   *
   * @generated from enum value: BATCH_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,
}

/**
 * Describes the enum bmi.v1.BatchStatus.
 */
export const BatchStatusSchema: GenEnum<BatchStatus> = /*@__PURE__*/
  enumDesc(file_bmi_v1_batch_message, 3);

/**
 * @generated from enum bmi.v1.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_ARGUMENT = 1;
   */
  INVALID_ARGUMENT = 1,

  /**
   * @generated from enum value: ERROR_CODE_UNAUTHENTICATED = 2;
   */
  UNAUTHENTICATED = 2,

  /**
   * @generated from enum value: ERROR_CODE_PERMISSION_DENIED = 3;
   */
  PERMISSION_DENIED = 3,

  /**
   * @generated from enum value: ERROR_CODE_NOT_FOUND = 4;
   */
  NOT_FOUND = 4,

  /**
   * @generated from enum value: ERROR_CODE_ALREADY_EXISTS = 5;
   */
  ALREADY_EXISTS = 5,

  /**
   * @generated from enum value: ERROR_CODE_FAILED_PRECONDITION = 6;
   */
  FAILED_PRECONDITION = 6,

  /**
   * @generated from enum value: ERROR_CODE_RESOURCE_EXHAUSTED = 7;
   */
  RESOURCE_EXHAUSTED = 7,

  /**
   * @generated from enum value: ERROR_CODE_UNIMPLEMENTED = 8;
   */
  UNIMPLEMENTED = 8,

  /**
   * @generated from enum value: ERROR_CODE_UNAVAILABLE = 9;
   */
  UNAVAILABLE = 9,

  /**
   * @generated from enum value: ERROR_CODE_INTERNAL = 10;
   */
  INTERNAL = 10,
}

/**
 * Describes the enum bmi.v1.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode> = /*@__PURE__*/
  enumDesc(file_bmi_v1_batch_message, 4);

